import { render } from "./text-editor.vue?vue&type=template&id=81bd9b4a"
import script from "./text-editor.vue?vue&type=script&lang=js"
export * from "./text-editor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__